import * as Yup from "yup";

export const InviteUserSchema = Yup.object().shape({
  email: Yup.string()
    .email("Email format is not valid")
    .required("This field is required."),
  role: Yup.string().required("This field is required."),
});
